import palette from '../palette';

export default {
  root:{
    backgroundColor: palette.colors.white,
    borderBottom: `0.5px solid ${palette.colors.fillStroke[50]}`
  }
};
